letterAdjust.x = 5;
letterAdjust.y = 10;
letterAdjust.scale = 0.97;

var font = {
    "0": "M0 114l110 -114h268l115 114v838l-115 113h-268l-110 -113v-838zM144 146v772h202v-772h-202z",
    "1": "M0 838v67l93 160h142v-917h71v-148h-282v148h69v690h-93z",
    "2": "M0 0v193l348 545v179h-203v-79h-145v114l110 113h268l112 -113v-258l-345 -546h345v-148h-490z",
    "3": "M0 116v109h145v-77h204v312h-101v146h101v311h-204v-79h-145v114l113 113h268l112 -113v-346l-72 -74l72 -72v-344l-112 -116h-268z",
    "4": "M0 244v180l341 641h132v-674h67v-147h-67v-96h67v-148h-281v148h69v96h-328zM146 391h182v340z",
    "5": "M0 113v112h145v-79h205v310h-350v609h495v-147h-350v-314h239l111 -113v-378l-111 -113h-272z",
    "6": "M0 113l112 -113h270l113 113v378l-113 113h-236v314h204v-80h145v112l-113 115h-270l-112 -115v-837zM146 146v310h204v-310h-204z",
    "7": "M0 838v227h506v-167l-223 -898h-148l227 918h-217v-80h-145z",
    "8": "M0 113l110 -113h270l113 113v343l-72 75l72 73v346l-113 115h-270l-110 -115v-346l72 -73l-72 -75v-343zM145 146v310h203v-310h-203zM145 604v314h203v-314h-203z",
    "9": "M0 113l110 -113h271l112 113v837l-112 115h-271l-110 -115v-377l110 -117h238v-310h-203v79h-145v-112zM145 604v314h203v-314h-203z",
    "A": "M0 0h138l26 274h195l26 -274h142l-104 1065h-320zM179 415l49 510h69l49 -510h-167z",
    "B": "M0 0h387l87 85v408l-51 49l51 53v385l-87 85h-387v-1065zM140 140v333h194v-333h-194zM140 612v313h194v-313h-194z",
    "C": "M0 85l83 -85h304l83 85v124h-138v-69h-194v785h194v-68h138v123l-83 85h-304l-83 -85v-895z",
    "D": "M0 0h389l85 85v895l-85 85h-389v-1065zM142 140v785h193v-785h-193z",
    "E": "M0 0h469v140h-331v333h168v139h-168v313h331v140h-469v-1065z",
    "F": "M0 0h140v473h166v139h-166v313h329v140h-469v-1065z",
    "G": "M0 85l83 -85h304l86 85v527h-238v-139h99v-333h-196v785h196v-68h139v123l-86 85h-304l-83 -85v-895z",
    "H": "M0 0h138v473h194v-473h141v1065h-141v-453h-194v453h-138v-1065z",
    "I": "M0 0h140v1065h-140v-1065z",
    "J": "M0 85l85 -85h304l84 85v980h-139v-925h-196v210h-138v-265z",
    "K": "M0 0h140v286l67 162l119 -448h128l-169 634l181 431h-152l-174 -417v417h-140v-1065z",
    "L": "M0 0h466v140h-328v925h-138v-1065z",
    "M": "M0 0h140v612l108 -286l104 282v-608h138v1065h-119l-123 -338l-127 338h-121v-1065z",
    "N": "M0 0h138v616l184 -616h151v1065h-139v-613l-184 613h-150v-1065z",
    "O": "M0 85l83 -85h304l86 85v895l-86 85h-304l-83 -85v-895zM138 140v785h196v-785h-196z",
    "P": "M0 0h140v473h249l84 85v422l-84 85h-389v-1065zM140 612v313h194v-313h-194z",
    "Q": "M0 88l83 -88h215l46 -84h93l-48 88l82 84v894l-84 83h-304l-83 -83v-894zM137 141v785h196v-785h-196z",
    "R": "M0 0h138v473h123l73 -473h140l-78 484l74 74v422l-85 85h-385v-1065zM138 612v313h194v-313h-194z",
    "S": "M0 85l85 -85h304l85 85v442l-85 85h-251v313h196v-68h140v123l-85 85h-304l-85 -85v-422l85 -85h249v-333h-196v69h-138v-124z",
    "T": "M0 925h187v-925h139v925h188v140h-514v-140z",
    "U": "M0 85l85 -85h302l86 85v980h-139v-925h-194v925h-140v-980z",
    "V": "M0 1065l156 -1065h166l156 1065h-143l-95 -669l-98 669h-142z",
    "W": "M0 1065l48 -1065h116l89 328l1 -2l92 -326h115l46 1065h-137l-24 -543l-93 328l-89 -327l-26 542h-138z",
    "X": "M0 0h146l87 293l87 -293h146l-161 534l160 531h-147l-85 -289l-87 289h-146l160 -531z",
    "Y": "M0 1065l172 -641v-424h141v427l169 638h-144l-97 -360l-97 360h-144z",
    "Z": "M0 925h310l-261 -753v-172h461v140h-323l275 797v128h-462v-140z"
};

var font_size = 27,
    newYork = true,
    panel_Hor_Adjustment = 2,
    font_Top_Adjustment = -20,
    tracking = 3.5,
    middleSplitAdjustment = -1,
    middleSpreadAdjustment = {
        left: 1,
        right: 1
    },
    small_Caps_Adjustment = {
        vertical: -255,
        horizontal: 0,
        scale_width: 0,
        scale_height: 0,
    },
    // Colors are in order like this...  home: [ inside, outline, outline2, outline3 ]
    colors = {
        characters: {
            home: [
                '#ba132d', // red
                "#FFFFFF", // white
            ],
            away: [
                "#002F87", // Blue
                '#CE0E2D', // Red
            ]
        },
        numbers: {
            home: [
                '#ba132d', // red
                "#FFFFFF", // white
            ],
            away: [
                "#002F87", // Blue
                '#CE0E2D', // Red
            ]
        }
    },
    outlines = {
        characters: {
            width: 2
        },
        numbers: {
            width: 5
        }
    },
    special_Character_Adjustments = {
        period: {
            vertical: 5, // this moves it up from the bottom
            horizontal: 1,
            scale_width: 15.5,
            scale_height: 15.5,
        },
        hyphen: {
            vertical: -6,
            horizontal: -5.5,
            scale_width: 0,
            scale_height: -3,
        },
        apostrophe: {
            vertical: 0.25, // this is backwards
            horizontal: -1,
            scale_width: 0,
            scale_height: 0,
        }
    },
    number_Adjustments = {
        top: 16,
        left: -4,
        width: 120,
        height: 95,
        middle_Space: 7,
    };
